module.exports = __webpack_public_path__ + "47d2b2f8bf73169d03bec956e073a009.pdf";